export const SET_REMOTE_IP = 'SET_REMOTE_IP'
